module.exports = __webpack_public_path__ + "img/19.ce68ed72.png";